import { Box, Button, Checkbox, FormControl, TextField, Tooltip } from '@mui/material';
import '../../styles/register.css';
import logo from '../../assets/images/logo/hbloginLogo.png';
import useRegister from '../../hooks/useRegister';
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const RegisterPage = () => {
    const { name, setName, email, setEmail, password, setPassword, confirmPassword, setConfirmPassword, code, setCode, terms, setTerms, handleSubmit } = useRegister();
    const { t } = useTranslation();

    return (
        <div className="registerBackground">
            <div className="registerWrapper">
                <div className="registerHeader">
                    <img className="hbloginLogo" src={logo} alt="hbloginLogo" />
                    <div className="registerTitle">{t('registration.register')}</div>
                    <div className="semiLinebreak"></div>
                </div>
                <Box alignItems={'center'}>
                    <FormControl>
                        <div className="registerContainerInner">
                            <form onSubmit={handleSubmit}>
                                <div className="entryContainer">
                                    <div className="entryTitle">{t('registration.name')}</div>
                                    <TextField
                                        hiddenLabel
                                        required
                                        autoComplete="off"
                                        id="filled-hidden-label-small"
                                        variant="filled"
                                        className="entryField"
                                        type="text"
                                        onChange={(e) => setName(e.target.value)}
                                        value={name}
                                    />
                                </div>

                                <div className="entryContainer">
                                    <div className="entryTitle">{t('login.email')}</div>
                                    <TextField
                                        hiddenLabel
                                        required
                                        autoComplete="off"
                                        id="filled-hidden-label-small"
                                        variant="filled"
                                        className="entryField"
                                        type="email"
                                        onChange={(e) => setEmail(e.target.value)}
                                        value={email}
                                    />
                                </div>

                                <div className="entryContainer">
                                    <div className="entryTitle">{t('login.password')}</div>
                                    <TextField
                                        hiddenLabel
                                        required
                                        autoComplete="off"
                                        id="filled-hidden-label-normal"
                                        variant="filled"
                                        className="entryField"
                                        type="password"
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                    />
                                </div>

                                <div className="entryContainer">
                                    <div className="entryTitle">{t('registration.confirmPassword')}</div>
                                    <TextField
                                        hiddenLabel
                                        required
                                        autoComplete="off"
                                        id="filled-hidden-label-normal"
                                        variant="filled"
                                        className="entryField"
                                        type="password"
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        value={confirmPassword}
                                    />
                                </div>

                                <div className="entryContainer">
                                    <div className="entryTitle" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        {t('registration.accreditationCode')}
                                        <Tooltip title={t('registration.accreditationCodeInfo')} placement="right" style={{ marginLeft: '8px' }}>
                                            <InfoOutlinedIcon fontSize="small" />
                                        </Tooltip>
                                    </div>
                                    <TextField
                                        hiddenLabel
                                        required
                                        autoComplete="off"
                                        id="filled-hidden-label-normal"
                                        variant="filled"
                                        className="entryField"
                                        type="text"
                                        onChange={(e) => setCode(e.target.value)}
                                        value={code}
                                    />
                                </div>

                                <div className="entryContainer" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <div className="entryTitle">
                                        {t('registration.agreeWith')} <a href="https://en.valkartech.com/conditions-d-utilisation">{t('registration.terms')}</a>
                                    </div>
                                    <Checkbox required onChange={(e) => setTerms(!terms)} value={terms} />
                                </div>

                                <div className="buttonRight gap">
                                    <Button type="submit" variant="contained" color="secondary" className="btn">
                                        {t('registration.register')}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </FormControl>
                </Box>
            </div>
        </div>
    );
};

export default RegisterPage;
